<template>
  <footer>
    <section class="footer-wrapper" style="background-color: #6c757d">
      <div class="container">
        <section
          class="row text-center d-flex justify-content-center pt-4"
          id="FooterUL"
        >
          <div class="col-md-2 padd">
            <h1>
              <router-link
                to="/contact"
                class="text-white route"
                id="FooterKontaktLink"
                >Kontakt</router-link
              >
            </h1>
          </div>

          <div class="col-md-2 padd">
            <h1>
              <router-link
                to="/jobs"
                class="text-white route"
                id="FooterJobLink"
                >Jobs</router-link
              >
            </h1>
          </div>

          <div class="col-md-2 padd">
            <h1>
              <router-link
                to="/imprint"
                class="text-white route"
                id="FooterImpressumLink"
                >Impressum</router-link
              >
            </h1>
          </div>

          <div class="col-md-2 padd">
            <h1>
              <router-link
                to="/legal"
                class="text-white route"
                id="FooterAGBLink"
                >Datenschutz</router-link
              >
            </h1>
          </div>
        </section>

        <hr class="my-5" />

        <section class="mb-5">
          <ul>
            <li>
              <a
                aria-label="Finde uns auf LinkedIn"
                href="https://www.linkedin.com/search/results/all/?fetchDeterministicClustersOnly=false&heroEntityKey=urn%3Ali%3Aorganization%3A7958890&keywords=lumabit%20gmbh&origin=RICH_QUERY_SUGGESTION&position=0&searchId=545a4002-8262-4c57-9eb9-b33ea487ac14&sid=010"
                class="text-white me-4"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i id="linkedin" class="fa-brands fa-linkedin-in"></i>
              </a>
            </li>
            <li>
              <a
                aria-label="Besuche unseren Youtube Kanal"
                href="https://www.youtube.com/@lumabit8487/videos"
                class="text-white me-4"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i
                  id="youtube"
                  class="fa-brands fa-youtube"
                  style="color: #fdfdff"
                ></i>
              </a>
            </li>
            <li>
              <a
                aria-label="Schicke eine Nachricht an uns"
                href="mailto:hello@lumabit.de"
                class="text-white"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i
                  id="mail"
                  class="fa-regular fa-envelope"
                  style="color: #fdfdff"
                ></i>
              </a>
            </li>
          </ul>
        </section>
      </div>

      <div class="text-center p-4" style="background-color: rgba(0, 0, 0, 0.2)">
        <p style="color: #fdfdff">© {{ currentyear }} LumaBIT GmbH</p>
      </div>
    </section>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      currentyear: "",
    };
  },
  created() {
    this.currentyear = new Date().getFullYear();
  },
};
</script>
<style scoped>
h1 {
  font-size: 1rem;
}
.route {
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease-out;
}
.router-link-exact-active,
.route:hover {
  font-weight: 900;
  font-size: 17px;
}

.font {
  font-family: "Roboto", sans-serif;
}
.padd{
  padding-top: 12px;
}
ul {
  display: flex;
  justify-content: center;
  padding: 0;
}
ul li {
  list-style: none;
}
ul li a {
  width: 40px;
  height: 40px;
  background-color: #6c757d;
  text-align: center;
  line-height: 38px;
  font-size: 18px;
  margin: 0 10px;
  display: block;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  border: 2px solid #f8f9fa;
  z-index: 1;
}
ul li a .icon {
  position: relative;
  color: #262626;
  transition: 0.5s;
  z-index: 1;
}
ul li a:hover .icon {
  color: #fdfdff;
  transform: rotateY(360deg);
  z-index: 2;
}
ul li a:before {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f00;
  transition: 0.5s;
  z-index: 0;
}
ul li a:hover:before {
  top: 0;
  z-index: -1;
}
ul li:nth-child(1) a:before {
  background: #0a66c2;
}
ul li:nth-child(2) a:before {
  background: #ff0000;
}
ul li:nth-child(3) a:before {
  background: #007bff;
}
</style>
